// paymentsMobileConfig.js — les seules différences entre Paiements sortants (Achats)
// et Paiements entrants (Ventes). Les deux écrans desktop sont des jumeaux à ~95 %.
//
// Note : `PaymentSortant.tsx:277-282` remappe la réponse de /api/users/suppliers en
// {ID_Frs, Nom_Raison_Sociale, USER_ID} avec `USER_ID = supplier.user_id || supplier.id`.
// Le backend (routes/users.js, buildEntitySelectQuery) renvoie en réalité {id, name} pour
// les DEUX endpoints : ce remappage est purement cosmétique, d'où une config unifiée.

export const PAYMENT_CONFIG = {
  out: {
    paymentType: "out",
    title: "Paiements sortants",
    singular: "paiement",
    entityLabel: "Fournisseur",
    entityPath: "/api/users/suppliers",
    unpaidPath: (id) => `/api/payments/unpaid-orders/supplier/${id}`,
    fallbackOrderType: "purchase",
    listEntityParam: "supplier_id",
    withTreasury: true,
    withStaffUser: true,
    permRoot: "Gestion Commerciale.Approvisionnement.Achats.PaiementsSortants",
    backPath: "/gestion-achats/paiements-sortants",
  },
  in: {
    paymentType: "in",
    title: "Paiements entrants",
    singular: "paiement",
    entityLabel: "Client",
    entityPath: "/api/users/customers",
    unpaidPath: (id) => `/api/payments/unpaid-orders/customer/${id}`,
    fallbackOrderType: "sales",
    listEntityParam: "customer_id",
    withTreasury: true,
    withStaffUser: false,
    permRoot: "Gestion Commerciale.Ventes.PaiementsEntrants",
    backPath: "/gestion-ventes/paiements-entrants",
  },
};

export const permsFor = (cfg) => ({
  view: `${cfg.permRoot}.view`,
  create: `${cfg.permRoot}.create`,
  edit: `${cfg.permRoot}.edit`,
  delete: `${cfg.permRoot}.delete`,
});

// MODULE_SCOPE = "commercial" (PaymentSortant.tsx:57)
export const MODULE_SCOPE = "commercial";
